import React, { useEffect } from 'react';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useLicenceContext } from 'models/licenceContext';

interface Props {
  onVerify: (token: string) => void;
}

export const RecaptchaGate = ({ onVerify }: Props) => {
  const { isOnlineLicence } = useLicenceContext();
  const enabled = isOnlineLicence();

  useEffect(() => {
    if (!enabled) {
      onVerify('recaptcha-disabled');
    }
  }, [enabled, onVerify]);

  if (!enabled) return null;

  return <GoogleReCaptcha onVerify={onVerify} />;
};
